import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

/*
 * Returns the week number for the current locale.
 * Accepts a date, string, number or Dayjs date as input
 */
export const getWeekNumber = (d: string | number | Date | dayjs.Dayjs) => {
  return dayjs(d).isoWeek();
};
